import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 350px;
  width: 64%;
  background: #d9d9d9;
  border-right: 4px solid #ffffff;
  align-items: center;

  #images {
    display: flex;
    padding-top: 20px;

    div#callBox {
      display: flex;
      justify-content: center;
    }

    div#callMe {
      display: flex;
      width: 50%;
      height: 50%;
      top: 0;
      justify-content: center;

    }
  }

  #icons {
     display: flex;
     flex-direction: row;
     width: 30%;
     padding: -40px;

  button{
    background: #d9d9d9;
    border: #d9d9d9;
  }

  div#tel {
    display: flex;

  }

  div#fim {
    display: flex;
  }

}
  video {
    width: 100%;
    -webkit-transform:rotateY(180deg); /* Safari and Chrome */
    -moz-transform:rotateY(180deg); /* Firefox */
  }
`;
